// extracted by mini-css-extract-plugin
export default {"list":"BasicInfo_list__19h-P","text":"BasicInfo_text__0nG-n","icon":"BasicInfo_icon__nGfpl"};